import React from 'react';
import { grey } from '@mui/material/colors';
import { Box, Stack, Typography } from '@mui/material';

import { FullReportResponse } from '../../types';

interface Props {
  group: FullReportResponse['list'][number];
}

export const ReportListingBeforeGroup = ({ group }: Props) => {
  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      <Typography>{group.meta.label}</Typography>

      <Box
        sx={{
          display: 'flex',
          width: '1.5rem',
          height: '1.5rem',
          alignItems: 'center',
          borderRadius: '100%',
          justifyContent: 'center',
          backgroundColor: grey[300],
        }}
      >
        <Typography>{group?.data?.length ?? 0}</Typography>
      </Box>
    </Stack>
  );
};
